import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { IRowNode } from 'ag-grid-community';
import { map } from 'rxjs';
import { BaseCellRendererComponent, Params } from '../base-cell-renderer.component';

export type ToggleCellRendererParamsValue = boolean;

export interface ToggleCellRendererParams<T = unknown> {
  disabled?: boolean;
  onStateChange: (node: IRowNode<T>, newState: ToggleCellRendererParamsValue) => void;
}

@UntilDestroy()
@Component({
  selector: 'y42-toggle-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatButtonToggleModule, StopPropagationModule],
  templateUrl: './toggle-cell-renderer.component.html',
  styleUrls: ['./toggle-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleCellRendererComponent extends BaseCellRendererComponent<
  ToggleCellRendererParamsValue,
  unknown,
  Params<ToggleCellRendererParamsValue, unknown, ToggleCellRendererParams>
> {
  readonly state = connectState(this, {
    isOn: this.value$,
    isDisabled: this.params$.pipe(map((params) => params.disabled)),
  });

  setState({ value }: MatButtonToggleChange) {
    this.params?.onStateChange(this.params.node, value);
  }
}
